import { Fragment, useId } from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import type { Figure } from './policyFigures';

/** A Policy Details card: a landmark named by its title, holding the rows it is given as a list of label and value. */
export function FigureCard({ title, figures }: { title: string; figures: Figure[] }) {
  const headingId = useId();
  return (
    <Card role="region" aria-labelledby={headingId}>
      <CardHeader>
        <h2 id={headingId} className="text-[15px] font-semibold">
          {title}
        </h2>
      </CardHeader>
      <CardContent>
        <dl className="grid grid-cols-[auto_minmax(0,1fr)] gap-x-3 gap-y-[7px] text-[13px]">
          {figures.map(({ label, text, numeric, note }) => (
            <Fragment key={label}>
              <dt className="whitespace-nowrap text-muted-foreground">{label}</dt>
              <dd title={note} className={cn('m-0 min-w-0 text-right break-words', numeric && 'font-mono tabular-nums')}>
                {text}
              </dd>
            </Fragment>
          ))}
        </dl>
      </CardContent>
    </Card>
  );
}
